import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Icon, ToolTip, Div, H3, H4 } from '@driftt/tide-core-legacy'
import Organizations from './Organizations'
import ACCESS from "utils/Access"
import appSwitcherIconSrc from './AppIcons/app-switch.svg'
import AppLink from './AppLink'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import {
  DRIFT_VIDEO_URL,
  SIFTROCK_URL,
  DRIFT_INSIDER_URL,
  DEVELOPERS_WEB_URL,
} from 'constants/ResourcesConstants'
import driftVideoIconSrc from './AppIcons/library.svg'
import siftrockIconSrc from './AppIcons/siftrock.svg'
import insiderIconSrc from './AppIcons/graduation-cap.svg'
import devPlatformIconSrc from './AppIcons/dev-platform.svg'
import './style.styl'

class AppSwitcher extends Component {

  state = {
    showAppSwitcher: false
  }

  openAppSwitcher = () => {
    const { showAppSwitcher } = this.state
    this.setState({ showAppSwitcher: !showAppSwitcher })
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (this.appSwitcherRef && !this.appSwitcherRef.contains(event.target)) {
      this.state.showAppSwitcher && this.setState({ showAppSwitcher: false })
    }
  }

  setAppSwitcherRef = (node) => {
    this.appSwitcherRef = node
  }

  getApps() {
    const { settingsLoaded, videoSignUpDone, trafficControlConfig: { hasDevPlatformSwitch, hasInsiderSwitch, hasVideoSwitch }} = this.props
    const apps = [
      {
        name: 'Siftrock',
        url: SIFTROCK_URL,
        iconSrc: siftrockIconSrc
      }
    ]

    if (hasInsiderSwitch) {
      apps.push({
        name: 'Insider',
        url: DRIFT_INSIDER_URL,
        iconSrc: insiderIconSrc
      })
    }

    if (hasDevPlatformSwitch) {
      apps.push({
        name: 'Developer Platform',
        url: DEVELOPERS_WEB_URL,
        iconSrc: devPlatformIconSrc
      })
    }

    if (settingsLoaded && this.props.showVideoOption && hasVideoSwitch) {
      apps.unshift({
        name: 'Drift Video',
        url: videoSignUpDone
          ? DRIFT_VIDEO_URL
          : `${DRIFT_VIDEO_URL}/accounts/existing-redirect`,
        iconSrc: driftVideoIconSrc
      })
    }

    return apps
  }

  render() {
    const { showAppSwitcher } = this.state

    if (ACCESS.isRbacUser() && 
    !ACCESS.hasGates('app_switcher')) { 
      return null
    }

    return (
      <div ref={this.setAppSwitcherRef}> { /* Tide Divs can't do refs */}
        <ToolTip className="navigation-hover-tooltip--wrapper" component={'Switch Apps'} flow="right">
          <Div className="nav-status-icon-wrapper" onClick={this.openAppSwitcher}>
            <img width={18} height={18} src={appSwitcherIconSrc} alt="app-switcher" />
          </Div>
        </ToolTip>
        <Div className={
          classnames(
            'drift-app-switch-nav',
            { 'open': showAppSwitcher }
          )}
        >
          <Div className="app-switcher-header">
            <Div className="app-switcher-back-button" onClick={() => this.setState({ showAppSwitcher: false })}>
              <Icon width={16} height={16} name="arrow-2-left"/>
            </Div>
            <H3 className="app-switcher-header-text">
              Switch to...
            </H3>
          </Div>
          {ACCESS.isMultiOrg() && <Organizations />}
          <Div className="app-switcher-app-list">
            <H4 className="app-switcher-app-list-header"> APPS </H4>
            { this.getApps().map(app => <AppLink app={app} key={app.name}/>) }
          </Div>
        </Div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    settingsLoaded: UserPropertiesSelectors.propertiesLoaded(state),
    videoSignUpDone: UserPropertiesSelectors.videoSignUpDone(state),
    trafficControlConfig: UserSelectors.trafficControlConfig(state),
  }
}

export default connect(mapStateToProps)(AppSwitcher)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/AppSwitcher/index.js